import type { HttpError } from '@refinedev/core'

export function createHttpError(error: unknown, statusCode: number): HttpError {
  const message =
    typeof error === 'object' && error !== null && 'message' in error
      ? String(error.message)
      : String(error)

  return { message, statusCode }
}

export function getErrorStatusCode(error: unknown): number {
  if (typeof error !== 'object' || error === null) {
    return 500
  }
  if ('statusCode' in error) {
    return Number(error.statusCode)
  }
  if ('status' in error) {
    return Number(error.status)
  }
  return 500
}
